import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0970163e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-section depository" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
    /*#__PURE__*/_createElementVNode("legend", null, "Depositary")
  ])
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]

import { computed, inject, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import _ from "lodash";
import { checkitem } from "@/utilities";
import { useEvent } from '@/eventBus';
import { Report, Room, Section, Type, Item, Note, DepositoryTenancy, Dictionary, DictionaryRoom } from "@/models";
import DepositoryPropertyListModal from "@/components/modals/DepositoryPropertylistModal.vue";
import ReportRoom from "@/components/depository/Room.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Depositary',
  setup(__props) {

const store = useStore();
const toast = useToast();

// Convert @Getter to computed properties
const hasUnsavedChanges = computed(() => store.getters['reports/hasUnsavedChanges']);
const dictionary = computed(() => store.getters['dictionary/current']);
const statereport = computed(() => store.getters['reports/current']);

// Convert @Action to methods using store.dispatch
const setReportDeep = (payload: { path: string; data: any }) => store.dispatch('reports/setReportDeep', payload);
const submitDeductionsToState = (id: string) => store.dispatch('reports/submitDeductions', id);
const uploadReportToState = (id: string) => store.dispatch('reports/uploadReport', id);

const focused = ref(-1);
const roomsShowBody = ref<boolean[]>([]);
const isSubmitting = ref(false);
const depositoryPropertyListModal = ref(null);
const cards = ref(null);

onMounted(() => {
  roomswithdeductions.value.forEach((room: Room, index) => {
    roomsShowBody.value[index] = true;
  });
});

const roomswithdeductions = computed(() => {
  let roomlist: Room[] = [];
  roomlist = statereport.value?.rooms?.filter((room: Room) => checkroom(room));
  return roomlist;
});

const getRoomIndex = (room: Room) => statereport.value?.rooms.findIndex((r: Room) => r._uuid === room._uuid);

const checkroom = (room: Room) => {
  let result = room?.sections.filter((section: Section) => checksection(room, section));
  return result?.length > 0;
};

const checksection = (room: Room, section: Section) => {
  let result = section?.types.filter((type: Type) => checktype(room, section, type));
  return result?.length > 0;
};

const checktype = (room: Room, section: Section, type: Type) => {
  let result = type?.items.filter((item: Item) => checkitem(room, section, type, item));
  return result?.length > 0;
};

const isCategoryFourRoom = (room: Room) => {
  let currentroomtype = room?.type;
  let found: number = dictionary.value.rooms.findIndex((dr: DictionaryRoom) => dr.category === 4 && dr.slug === currentroomtype);
  return found >= 0;
};

const showDepositoryPropertyListModal = () => {
  const modal = depositoryPropertyListModal.value as any; // Make sure to define refs correctly
  modal.init(statereport.value);
  
  (modal.$el as any).modal("show");
};

const linkDepositoryTenancy = (tenancy: DepositoryTenancy) => {
  setReportDeep({ path: "depositorytenancy", data: tenancy });
  const modal = depositoryPropertyListModal.value as any; // Define refs correctly
  (modal.$el as any).modal("hide");
};

const unlinkTenancy = () => {
  setReportDeep({
    path: "depositorytenancy",
    data: new DepositoryTenancy(),
  });
};

const submitDeductions = () => {
  if (statereport.value.id) {
    isSubmitting.value = true;
    submitDeductionsToState(statereport.value.id).then(() => {
      toast.success(`Posted all deductions to Depositary`);
      isSubmitting.value = false;
    });
  }
};

const submitToDepository = (tenancy: DepositoryTenancy) => {
  setReportDeep({ path: "depositorytenancy", data: tenancy });
  const modal = depositoryPropertyListModal.value as any;
  (modal.$el as any).modal("hide");
};

const uploadReport = () => {
  if (statereport.value.id) {
    isSubmitting.value = true;
    uploadReportToState(statereport.value.id).then(() => {
      toast.success(`Successfully uploaded report PDF and meter readings to Depositary`);
      isSubmitting.value = false;
    });
  }
};

/**
 * Expand all rooms
 */
const expandAll = (): void => {
  const roomsOpened: boolean[] = [];
  if (cards.value) {
    (cards as any[]).forEach((card, index) => {
      card.showBody = true;
      roomsOpened[index] = true;
    });
  }

  roomsShowBody.value = roomsOpened;
}

/**
 * Collapse all rooms
 */
const collapseAll = (): void => {
  const roomsClosed: boolean[] = [];
  if (cards.value) {
    (cards as any[]).forEach((card, index) => {
      card.showBody = false;
      roomsClosed[index] = false;
    });
  }
  roomsShowBody.value = roomsClosed;
}

useEvent("expandAll", () => expandAll());
useEvent("collapseAll", () => collapseAll());

/**
 * Highlight Current active Room
 */
const setActiveCard = (index: any) => {
  focused.value = index;
}

/**
 * Show/Hide Room Body
 *
 * @param {Number} index
 * @param {Boolean} showBody
 * @returns boolean value if room body is shown/hidden
 */
const syncRoomsShowBody = (index: number, showBody: boolean) => {
  const cardsrefArray = cards as any[];
  if (cardsrefArray.length !== roomsShowBody.value.length) {
    // To cope with adding/removing rooms
    // or sometimes mounted won't set up roomsShowBody.value correctly
    const rooms: boolean[] = [];
    for (let i = 0; i < cardsrefArray.length; i++) {
      if (roomsShowBody.value[i] === undefined) {
        rooms[i] = true;
      } else if (i === index) {
        rooms[i] = showBody;
      } else {
        rooms[i] = roomsShowBody.value[i];
      }
    }
    roomsShowBody.value = rooms;
  } else {
    roomsShowBody.value = roomsShowBody.value.map((value, i) => {
      return i === index ? showBody : value;
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (statereport.value && statereport.value.depositorytenancy && statereport.value.depositorytenancy.uid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roomswithdeductions.value, (room, $index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card",
              key: room._uuid,
              onClick: _withModifiers(($event: any) => (setActiveCard($index)), ["stop"])
            }, [
              _createVNode(ReportRoom, {
                room: room,
                index: getRoomIndex(room),
                opened: 
            roomsShowBody.value[$index] === undefined ? true : roomsShowBody.value[$index]
          ,
                toggle: true,
                class: _normalizeClass({ activeCard: focused.value === $index }),
                ref_for: true,
                ref_key: "cards",
                ref: cards,
                onShowBody: syncRoomsShowBody
              }, null, 8, ["room", "index", "opened", "class"])
            ], 8, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(DepositoryPropertyListModal, {
      ref_key: "depositoryPropertyListModal",
      ref: depositoryPropertyListModal,
      onSelect: linkDepositoryTenancy,
      onSubmit: submitToDepository
    }, null, 512)
  ]))
}
}

})